/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import moment from "moment";

interface RomaneioVenda {
  idmov: string;
  emissao: string;
  numero: string | null;
  nome: string;
  cpf: string;
  descricao: string;
  vprod: number;
  desconto: number;
  acrescimo: number;
  total: number;
  tpag: string;
}

async function RelatorioVendas(dados: RomaneioVenda[], periodo: string) {

  const totalGeral = dados.reduce(
    (acc, item) => acc + (item?.total ?? 0),
    0
  );

  const linhas: any[] = [];

  dados.forEach((r) => {

    linhas.push([
      {
        text: moment(r.emissao).format("DD/MM/YYYY"),
        fontSize: 8
      },
      {
        text: r.numero ?? "",
        fontSize: 8
      },
      {
        text: r.nome + "\nCPF/CNPJ: " + r.cpf,
        fontSize: 8
      },
      {
        text: r.descricao,
        fontSize: 8
      },
      {
        text: formatMoney(r.vprod),
        alignment: "right",
        fontSize: 8
      },
      {
        text: formatMoney(r.desconto),
        alignment: "right",
        fontSize: 8
      },
      {
        text: formatMoney(r.acrescimo),
        alignment: "right",
        fontSize: 8
      },
      {
        text: formatMoney(r.total),
        alignment: "right",
        bold: true,
        fontSize: 8
      }
    ]);

  });

  const documentDefinition: any = {

    pageSize: "A4",
    pageMargins: [25, 25, 25, 25],

    content: [

      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 14,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4]
      },

      {
        text: "RELATÓRIO DE VENDAS",
        fontSize: 12,
        bold: true,
        alignment: "center"
      },

      {
        text: periodo,
        alignment: "center",
        fontSize: 9,
        margin: [0, 0, 0, 10]
      },

      {
        table: {
          headerRows: 1,
          widths: [50, 30, "*", 60, 40, 40, 40, 40],
          body: [
            [
              { text: "Data", bold: true, fillColor: "#e5e7eb", color: "#111827" },
              { text: "Nº", bold: true, fillColor: "#e5e7eb", color: "#111827" },
              { text: "Cliente", bold: true, fillColor: "#e5e7eb", color: "#111827" },
              { text: "Descrição", bold: true, fillColor: "#e5e7eb", color: "#111827" },
              { text: "V.Prod", bold: true, alignment: "right", fillColor: "#e5e7eb", color: "#111827" },
              { text: "Desc", bold: true, alignment: "right", fillColor: "#e5e7eb", color: "#111827" },
              { text: "Acrés", bold: true, alignment: "right", fillColor: "#e5e7eb", color: "#111827" },
              { text: "Total", bold: true, alignment: "right", fillColor: "#e5e7eb", color: "#111827" }
            ],

            ...linhas

          ]
        },

        layout: {

          fillColor: function (rowIndex: number) {

            if (rowIndex === 0) return null;

            return rowIndex % 2 === 0 ? "#f9fafb" : null;

          },

          hLineColor: () => "#d1d5db",
          vLineWidth: () => 0
        }
      },

      {
        text: "TOTAL GERAL: " + formatMoney(totalGeral),
        alignment: "right",
        bold: true,
        fontSize: 11,
        margin: [0, 15, 0, 0]
      }

    ]

  };

  pdfMake.createPdf(documentDefinition).open();
}

function formatMoney(value: number) {

  const v = Number(value ?? 0);

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));

}

export default RelatorioVendas;